// おすすめ・特集物件モーダル（Figma PC 5266:22952 / SP 5266:25202）
// 総合版フローティング「おすすめ物件」→エリア選択後は ymh_feature_popup_pending で1回自動表示
const PENDING_KEY = 'ymh_feature_popup_pending';

const main = () => {
    const popup = document.querySelector('.js-home-feature-popup');
    if (!popup) return;

    const open = () => {
        popup.setAttribute('data-active', 'true');
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    };
    const closeOnly = () => {
        popup.setAttribute('data-active', 'false');
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    };

    popup.querySelectorAll('[data-close]').forEach((el) => {
        el.addEventListener('click', closeOnly);
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.getAttribute('data-active') === 'true') closeOnly();
    });

    document.querySelectorAll('.js-home-feature-popup-open, [data-home-feature-popup-open]').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            if (document.body.hasAttribute('data-menu-active')) {
                document.body.removeAttribute('data-menu-active');
                document.querySelectorAll('.js-drawer-toggle').forEach((btn) => {
                    btn.setAttribute('aria-expanded', 'false');
                });
            }
            open();
        });
    });

    // 総合版→エリア選択直後のみ1回表示
    let pending = false;
    try { pending = sessionStorage.getItem(PENDING_KEY) === '1'; } catch (e) { pending = false; }
    if (pending) {
        try { sessionStorage.removeItem(PENDING_KEY); } catch (e) { /* noop */ }
        window.requestAnimationFrame(open);
    }
};

export default main;
